module.exports = __webpack_public_path__ + "media/images/logo-10d749941c58419c1721d9274542cff8.png";